import { FC } from 'react';
import CreateJob from 'containers/jobs/create-edit-job/CreateJob';
import { useGetTaxesAndFeesQuery } from 'containers/invoices/api';
import { useAppSelector } from 'hooks';
import { selectCurrentTeam } from 'containers/app/appSlice';
import { Loader } from 'components';

interface CreateJobPageProps {
  isEdit?: boolean;
}

const CreateJobPage: FC<CreateJobPageProps> = ({ isEdit = false }) => {
  const currentTeam = useAppSelector(selectCurrentTeam);

  const { isFetching: isLoadingTaxesAndFees } = useGetTaxesAndFeesQuery({
    teamId: currentTeam?.id
  });

  if (isLoadingTaxesAndFees) {
    return <Loader />;
  }

  return <CreateJob isEdit={isEdit} />;
};

export default CreateJobPage;
